import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable()
export class DebugMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    console.warn('Missing translation:', {
      key: params.key,
      translateService: params.translateService,
      interpolateParams: params.interpolateParams,
    });
    
    return `[MISSING: ${params.key}]`;
  }
}